import { apiClient } from "./apiClient";

export const journalApi = {
  // scope: "mine" (default), "team", or "all". The server decides what is
  // readable at all -- V076's RLS predicate, which is the only rule in
  // the schema that does not let an account owner read everything. Scope
  // only chooses among the entries already permitted.
  list: (scope = "mine", params = {}) =>
    apiClient.get("/journal", { params: { scope, ...params } }).then((r) => r.data),

  // PRIVATE unless share_with_team is passed. The default is the point.
  create: (payload) => apiClient.post("/journal", payload).then((r) => r.data),

  update: (entryId, body) =>
    apiClient.put(`/journal/${entryId}`, { body }).then((r) => r.data),

  // Both directions through one call: sharing and pulling back are the
  // same decision made twice.
  setShared: (entryId, shared) =>
    apiClient.post(`/journal/${entryId}/share`, { shared }).then((r) => r.data),

  remove: (entryId) => apiClient.delete(`/journal/${entryId}`).then((r) => r.data),

  // ── The author's own filing (#464) ────────────────────────────────
  //
  // Per PERSON, not per account, following V076's anchor rather than
  // this codebase's usual one -- and a tag does NOT travel with a
  // shared entry. Somebody may reasonably tag an entry
  // 'dispute-with-supplier', and that must not become visible to the
  // account owner because the entry was later shared.
  listTags: () => apiClient.get("/journal/tags").then((r) => r.data),

  createTag: (name) => apiClient.post("/journal/tags", { name }).then((r) => r.data),

  // SOFT. Entries already carrying it keep it -- tidying a tag list must
  // never silently unfile work somebody did months ago.
  deleteTag: (tagId) => apiClient.delete(`/journal/tags/${tagId}`).then((r) => r.data),

  // The WHOLE set for one entry, not an addition. The screen edits a row
  // of chips, so it sends the set it wants and the two cannot disagree
  // about what was removed.
  setTags: (entryId, tagIds) =>
    apiClient.put(`/journal/${entryId}/tags`, { tag_ids: tagIds }).then((r) => r.data),

  // One of the palette, or null to clear it.
  setColour: (entryId, colour) =>
    apiClient.put(`/journal/${entryId}/colour`, { colour }).then((r) => r.data),

  setPinned: (entryId, pinned) =>
    apiClient.put(`/journal/${entryId}/pin`, { pinned }).then((r) => r.data),
};
